import React from 'react';
import { MessageCompose, PrivateLayout, ResourceContent } from '../components';
import { ROUTE_PATHS } from '../utils';

export const MessageComposeView = () => {
  return (
    <ResourceContent
      contentKey='message.title'
      render={({ content: titlePrefix }: { content: string }) => (
        <PrivateLayout
          breadcrumbs={[{ label: 'Messages / Compose message', href: ROUTE_PATHS.messages }]}
          pageTitle={'COMPOSE MESSAGE'}
          pageIcon={<i className='fa-light fa-envelope'></i>}>
          <MessageCompose />
        </PrivateLayout>
      )}
    />
  );
};
